export default __webpack_public_path__ + "static/1082-89bbc330438726dfbcdc6867c474af00.gif";